import InvoiceListing from "../../Components/Customers/InvoiceListing";

export default function InvoiceList() {
    return(
        <InvoiceListing/>
    )
}